(function() {
  var cartToggle = document.getElementById('cart-toggle-btn');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBackdrop = document.getElementById('cart-backdrop');

  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  }

  window.openCart = function() {
    if (cartDrawer) cartDrawer.style.transform = 'translateX(0)';
    if (cartBackdrop) {
      cartBackdrop.classList.remove('hidden');
      cartBackdrop.style.opacity = '1';
    }
    document.body.style.overflow = 'hidden';
  };

  window.closeCart = function() {
    if (cartDrawer) cartDrawer.style.transform = 'translateX(100%)';
    if (cartBackdrop) {
      cartBackdrop.style.opacity = '0';
      setTimeout(function() { cartBackdrop.classList.add('hidden'); }, 300);
    }
    document.body.style.overflow = '';
  };

  window.updateCartItem = function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      location.reload();
    })
    .catch(function(err) {
      console.error('Cart update failed:', err);
    });
  };
})();
